export class Consulta {
  descricao: string;
  id: number;
  nome: string;
  permissaoClienteConsulta: number;
  tipoConsulta: string;
  tipo:string;
  disabled = false;
  checked = false;
  codigoControle: { status: number };
  valor: number;
  token: string = '';
  selfChecked: boolean;
  
  constructor(consulta) {
    this.descricao = consulta['descricao'] || null;
    this.id = consulta['id'] || consulta['idCombinada'] || null;
    this.nome = consulta['nome'] || consulta['nomeConsulta'] || consulta['nomeconsulta'] || '';
    this.tipoConsulta = consulta['tipoConsulta'] || consulta['tipo'] || null;
    this.tipo = consulta['tipo'] || '';
    this.codigoControle = consulta['codigoControle'] || null;
    this.permissaoClienteConsulta = consulta['permissaoClienteConsulta'] || null;
    this.valor = consulta['valor'] || 0;
    this.checked = consulta['checked'] || false;
  }

}
